import React from 'react';
import { Link } from 'react-router-dom';
import '../infrastructure.css';

export default function InfraFooter() {
  return (
    <>
      <footer className="infra-footer" data-testid="infra-footer">
        <div className="infra-footer-grid">
          <div>
            <div className="infra-footer-brand">Pebbles</div>
            <div className="infra-footer-tagline">The financial OS companies build on.</div>
          </div>
          <div>
            <div className="infra-footer-heading">PRODUCTS</div>
            <Link to="/infrastructure/payroll" className="infra-footer-link">Payroll &amp; Benefits</Link>
            <Link to="/infrastructure/wallets" className="infra-footer-link">Virtual Wallets</Link>
            <Link to="/infrastructure/collect" className="infra-footer-link">Collect</Link>
            <Link to="/infrastructure/connect" className="infra-footer-link">Connect</Link>
            <Link to="/infrastructure/comply" className="infra-footer-link">Comply</Link>
            <Link to="/infrastructure/agents" className="infra-footer-link">Agent Wallets</Link>
          </div>
          <div>
            <div className="infra-footer-heading">DEVELOPERS</div>
            <Link to="/infrastructure/developers" className="infra-footer-link">Documentation</Link>
            <Link to="/infrastructure/developers" className="infra-footer-link">API reference</Link>
            <Link to="/infrastructure/developers" className="infra-footer-link">SDKs</Link>
            <Link to="/infrastructure/developers" className="infra-footer-link">Webhooks</Link>
          </div>
          <div>
            <div className="infra-footer-heading">COMPANY</div>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">About</a>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">Blog</a>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">Careers</a>
            <a href="mailto:hello@thcohq.com" className="infra-footer-link">Security</a>
          </div>
        </div>
      </footer>
      <div className="infra-bottom" data-testid="infra-bottom-bar">
        <span className="infra-bottom-text">&copy; 2026 THCO</span>
        <span className="infra-bottom-text">pebbles.financial</span>
      </div>
    </>
  );
}
